import classNames from "classnames";
import { TextBlockProps } from "./TextBlock.types";

/**
 * A paragraph of guidance on a form. Content is plain text: rendering
 * author-supplied HTML into a page every user sees is a decision about
 * cross-site scripting, and it isn't made in passing here.
 */
export function TextBlock({ content, className = "" }: TextBlockProps) {
  return (
    <p className={classNames("mb-0 text-break", className)}>{content}</p>
  );
}

export default TextBlock;
